import { Component, ViewEncapsulation } from '@angular/core';
import { UIBlockingService } from '../core/ui-blocking.service';
import { MemberAdService } from './member-ad.service';
import { ToastNotificationService } from '../core/toast-notification.service';
import { GetMemberAdsListRequest } from './DTOs/get-member-ad-list-request';
import { Observable, merge } from 'rxjs';
import { MemberAdsDtRetInfo } from './DTOs/member-ad-dt-ret-info';
import { CommonLibrary } from '../core/common-library';
import { AdType, AdTypeGroup } from './DTOs/AdTypes';
import { UpgradeInterestModalComponent } from './Modals/upgrade-interest-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ads',
  templateUrl: './ads.component.html',
    encapsulation: ViewEncapsulation.None,
  providers: [UIBlockingService]
})
export class AdsComponent {
    constructor(private memberAdService: MemberAdService,
        private notificationService: ToastNotificationService,
        private blockUI: UIBlockingService
        , private modalService: NgbModal) { }

    protected readonly CommonLibrary = CommonLibrary;

    groups = [];

    previousAds = [];

    totalAds = 0;
    filteredAds = 0;
    pageNum = 1;
    itemsPerPage = 10;
    initialLoad = true;
    filtersChanged = false;
    searchText = "";
    sortType = 6;
    keywordSearches: string[] = [];
    typeSearch = { display: "All", value: 0 };


    membership = "";

    ngOnInit() {
        this.getMembershipLevel();
        this.getAdTypes();
    }

    getMembershipLevel() {
        this.getMembershipLevelObservable()
            .subscribe(
                {
                    next: (data) => {
                        this.membership = data;
                    },
                    error: (err) => {
                        this.notificationService.error(err.message);
                        this.getPreviousAds();
                        console.log(err)
                    },
                    complete: () => {
                        this.getPreviousAds();
                    }
                });
    }

    getAdTypes() {
        this.blockUI.start();
        this.getAdTypesObservable()
            .subscribe(
                {
                    next: (data) => {
                        this.groups = data;
                    },
                    error: (err) => {
                        this.notificationService.error(err.message);
                        this.getPreviousAds();
                        console.log(err)
                    },
                    complete: () => {
                        this.getPreviousAds();
                    }
                });
    }

    getPreviousAds() {
        if (this.filtersChanged) this.blockUI.start();
        this.getPreviousAdsObservable()
            .subscribe(
                {
                    next: (data) => {
                        this.previousAds = data.data;
                        this.totalAds = data.recordsTotal;
                        this.filteredAds = data.recordsFiltered;
                    },
                    error: (err) => {
                        this.notificationService.error(err.message);
                        this.blockUI.stop();
                        console.log(err)
                    },
                    complete: () => {
                        this.blockUI.stop();
                    }
                });
    }

    getPreviousAdsObservable(): Observable<MemberAdsDtRetInfo> {
        var req = this.createSearchRequest();
        return this.memberAdService
            .getPreviousAdList(req);
    }

    getAdTypesObservable(): Observable<AdTypeGroup[]> {
        return this.memberAdService
            .getAdTypeOptions();
    }

    getMembershipLevelObservable(): Observable<string> {
        return this.memberAdService.getMembershipLevel();
    }

    createSearchRequest(): GetMemberAdsListRequest {
        var req = new GetMemberAdsListRequest();

        if (this.filtersChanged)
            this.pageNum = 1;

        req.PageNumber = this.pageNum - 1; //to get the 0-indexed number
        req.ItemsPerPage = this.itemsPerPage;

        req.KeywordSearches = this.keywordSearches;
        req.Sorting = this.sortType;
        req.typeFilter = this.typeSearch.value;

        this.filtersChanged = false;
        return req;
    }


    get currentPageNum() { return this.pageNum };
    set currentPageNum(page: number) {
        this.pageNum = page;
        if (!this.initialLoad)
            this.getPreviousAds();
    }

    get itemStart() {
        return ((this.currentPageNum - 1) * this.itemsPerPage) + 1;
    }

    get itemEnd() {
        return ((this.currentPageNum - 1) * this.itemsPerPage) + this.previousAds.length;
    }

    clearSearch() {
        this.searchText = "";
        this.sortType = 1;
        this.keywordSearches = [];
        this.filtersChanged = true;
        this.getPreviousAds();
    }

    hitSearchBtn() {
        this.searchText.trim().split(' ').forEach((term) => this.keywordSearches.push(term));
        this.searchText = '';
        this.filtersChanged = true;
        this.getPreviousAds();
    }

    removeSearchTerm(term: string) {
        var index = this.keywordSearches.indexOf(term);
        if (index != -1) {
            this.keywordSearches.splice(index, 1);
            this.filtersChanged = true;
        }
        this.getPreviousAds();
    }

    enterSearchTerm(event: any) {
        if (event.keyCode != 13) {//13 is enter, 32 is space
            return;
        }

        this.searchText.trim().split(' ').forEach((term) => this.keywordSearches.push(term));
        this.searchText = '';
        this.filtersChanged = true;
        this.hitSearchBtn();
        return;
    }

    changeTypeSearch(toChange: number) {
        if (this.typeSearch.value == toChange)
            return;

        this.filtersChanged = true;
        switch (toChange) {
            case 1:
                this.typeSearch = { display: "Monday Morning Memo", value: 1 };
                break;
            case 2:
                this.typeSearch = { display: "Monthly Event Notice", value: 2 };
                break;
            case 3:
                this.typeSearch = { display: "Member Directory Spotlight", value: 3 };
                break;
            case 4:
                this.typeSearch = { display: "Annual Report", value: 4 };
                break;
            default:
                this.typeSearch = { display: "All", value: 0 };
                break;
        }
        this.getPreviousAds();
    }

    changeSortType(column: number) {
        this.filtersChanged = true;
        switch (column) {
            case 7:
                this.sortType = (this.sortType == 7) ? 8 : 7;
                break;
            case 5:
                this.sortType = (this.sortType == 5) ? 6 : 5;
                break;
            case 9:
                this.sortType = (this.sortType == 9) ? 10: 9;
                break;
            default:
                break;
        }
        this.getPreviousAds();
    }

    downloadAdImage(ad) {
        this.memberAdService.getAdImageUrl(ad.adId)
            .subscribe({
                next: (data) => {
                    CommonLibrary.downloadImageByUrl(data, ad.memberCompany + '_Ad_' + CommonLibrary.formatDateIntoString(ad.submissionDate));
                },
                error: (err) => {
                    this.notificationService.error(err.error.message);
                    console.log(err);
                }
            });
    }

    openUpgradeModal() {
        const modalRef = this.modalService.open(UpgradeInterestModalComponent, { size: 'sm', backdrop: 'static' });
        modalRef.result.then(response => {
            this.notificationService.success("Member Services has been notified of your interest and will reach out!")
        })
            .catch(err => { });
    }
}
